export const exitModalMessage = {
  title: 'Label.ContinueOrExit',
  body: 'Description.ContinueChildRequest',
  actionBtnText: 'Action.Continue',
  neturalBtnText: 'Action.ExitSetup'
};

export const chargebackWizardSessionToken = 'Roblox.ChargebackWizardSessionToken';
export const logoutMessage = {
  body: 'Description.LogOutSignup',
  title: 'Title.LogOut',
  actionBtnText: 'Action.Logout'
};
export const invalidParentLinkMessage = {
  title: 'Title.InvalidLink',
  body: 'Description.InvalidParentAccountLink',
  actionBtnText: 'Action.OK'
};
